module.exports = __webpack_public_path__ + "assets/img/37_388.fd67f7f9.jpg";